<template>
  <div class="statistic">
    <span class="name">{{ props.name }}</span>
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
}>()
</script>

<style scoped lang="postcss">
.statistic {
  margin-bottom: 0.25em;

  .name {
    font-weight: 500;
    color: var(--text-highlight);
    margin-right: 0.25em;
  }
}
</style>
